const extractionConfiguration = {
  ExtractionConfiguration: "Extraction Configuration",
  extraction_configuration: "Extraction Configuration",
  keep_first_page_title: "Keep only the first page",
  keep_first_page_description:
    "If the document text contains any of the tags below, only page 1 of the PDF is processed. Runs before classification.",
  remove_watermark_title: "Remove watermark",
  remove_watermark_description:
    'If the document text contains any of the tags below, the watermark is removed. Runs after "Keep only the first page", so it only sees page 1 when that applied.',
  tags_placeholder: "Type a tag and press Enter",
  tags_hint:
    "Matching ignores upper/lower case. Max {{max}} tags, {{length}} characters each.",
  add: "Add",
  enable_toggle_to_edit_tags: "Enable the toggle to add or edit tags",
  save: "Save",
  configuration_saved_successfully: "Configuration saved successfully",
  organization_not_found: "Organization not found.",
  extraction_config_organization_id_mismatch:
    "The organization in the URL and in the request do not match.",
  extraction_config_watermark_tags_required:
    "Add at least one watermark tag to enable watermark removal.",
  extraction_config_watermark_tags_max_exceeded:
    "No more than {{max}} watermark tags are allowed.",
  extraction_config_watermark_tag_too_long:
    "A watermark tag can not be longer than {{max}} characters.",
  extraction_config_keep_first_page_tags_required:
    "Add at least one tag to enable keeping only the first page.",
  extraction_config_keep_first_page_tags_max_exceeded:
    "No more than {{max}} tags are allowed.",
  extraction_config_keep_first_page_tag_too_long:
    "A tag can not be longer than {{max}} characters.",
};

export default extractionConfiguration;
